import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { BaseDetailView } from "./BaseDetailView";

import * as React from 'react';
import { renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { ApplicationData } from "../../ApplicationData";
import { LocationConfigurationProvider } from "@tlc/ls2pac/components/LocationConfiguration";
import { BranchLimitProvider } from "@tlc/ls2pac/components/BranchLimits";
import { GlobalConfigProvider } from "@tlc/ls2pac/components/GlobalConfig";
import { StackMapProvider } from "@tlc/ls2pac/components/Stackmap";
import { AllCopies } from "@tlc/ls2pac/components/pages/resource/AllCopies";
import { LocalHoldingsBranchProvider } from "@tlc/ls2pac/components/pages/resource/LocalHoldingsBranch";
import { AccountProvider } from "@tlc/ls2pac/components/Account";
import { StationLocationProvider } from "@tlc/ls2pac/components/StationLocation";
import { SupportedFunctionalityProvider } from "@tlc/ls2pac/components/SupportedFunctionality";

export class Titles_AllCopies extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.resultsTemplate = "tmpl/details/titles_allCopies.html";
    options.id = LS2PAC_CONSTANTS.Ids.DetailsPage.allCopiesContainer;

    super(options);

    this.addListeners();
  }

  load(resourceData, index, viewName) {
    const allCopiesTableContainerId = "allCopiesTable"
    const copiesTableHasRendered = document.getElementById(allCopiesTableContainerId);
    if(copiesTableHasRendered) return;

    $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.allCopiesSpinner).spin("small");

    // const branchToUse = ApplicationData.getBranchToUseForAvailability();

    const fullDetailsContainer = document.getElementById(this.id);
    const divElement = document.createElement('div');
    divElement.id = 'table-container';
    fullDetailsContainer.appendChild(divElement);

    const copiesTableCallback = () => {
      $("#" + LS2PAC_CONSTANTS.Ids.DetailsPage.allCopiesSpinner).spin(false);
      this.parentClass.setRequestButton();
      this.parentClass.updatePagingControls();
    }    

    renderWithoutShadow(
      <div id={allCopiesTableContainerId}>
        <GlobalConfigProvider>
        <LocationConfigurationProvider>
          <StackMapProvider>
            <BranchLimitProvider>
              <StationLocationProvider>
                <SupportedFunctionalityProvider>
                <AccountProvider>
                  <LocalHoldingsBranchProvider>
                    <AllCopies resource={this.currentResource} />
                  </LocalHoldingsBranchProvider>
                </AccountProvider>
                </SupportedFunctionalityProvider>
              </StationLocationProvider>
            </BranchLimitProvider>
          </StackMapProvider>
        </LocationConfigurationProvider>
        </GlobalConfigProvider>
      </div>, 
      divElement, ApplicationData.language)
      copiesTableCallback();
  }
}
